/**
 * Play a simple beep sound for notifications
 * Uses Web Audio API to create synthetic beep sounds
 */
export function playNotificationSound(): void {
  try {
    // Create audio context
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // Create oscillator for beep sound
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // Connect nodes
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Configure beep sound
    oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // 800Hz frequency
    oscillator.type = 'sine';
    
    // Configure volume envelope
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
    
    // Play sound
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
    
  } catch (error) {
    console.warn('Could not play notification sound:', error);
    // Fallback: try using the system beep
    try {
      // This might work in some browsers
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjiU2/LXiT0IGWK18+GRQAW5');
      audio.play();
    } catch (fallbackError) {
      console.warn('Could not play fallback sound:', fallbackError);
    }
  }
}

/**
 * Play work session start sound
 */
export function playWorkStartSound(): void {
  playNotificationSound();
}

/**
 * Play break session start sound
 */
export function playBreakStartSound(): void {
  playNotificationSound();
}

/**
 * Play session completion sound
 */
export function playSessionCompleteSound(): void {
  playNotificationSound();
}

/**
 * Check if audio notifications are supported
 */
export function isAudioSupported(): boolean {
  return !!(window.AudioContext || (window as any).webkitAudioContext);
} 